import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { tabselected } from "../../consts.js";
import { useThemeMode } from '../../components/theme/index.jsx';

function SettingHeader({ title, selectedTab }) {
    let navigate = useNavigate();
    const { colours, FONT } = useThemeMode();

    return (
        <>
            {/* <Stack gap={1} flexDirection="row" flexWrap="wrap" alignItems="center" sx={{wordBreak: 'break-word', padding: { xs: "10px 12px", md: "10px 24px" }, marginBottom: .5 }}>
                <Stack flexDirection="row" gap={.5}>
                    <FeatherIcon icon="settings" style={{flexShrink: 0 }} />
                    <Typography component="div">Settings /</Typography>
                </Stack>
                <Stack flexDirection="row" gap={.5}>
                    <FeatherIcon icon="list" style={{flexShrink: 0 }} />
                    <Typography component="div" sx={{fontWeight: "bolder", borderBottom: "solid 2px"}}>{title}</Typography>
                </Stack>
            </Stack> */}
            <Grid
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                borderBottom={colours.dividergraybottomborder}
                paddingX={1}
                alignItems="center"
                gap={1}
            >
                <Typography
                    component="div"
                    display="flex"
                    flexDirection="row"
                    marginRight="auto"
                    alignItems={{ xs: 'end', sm: 'normal' }}
                >
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Companies", colours, FONT)}
                        onClick={() => {
                            navigate("/companies");
                        }}
                    >
                        Companies
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "User setup", colours, FONT)}
                        onClick={() => {
                            navigate("/users");
                        }}
                    >
                        User setup
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Insight admin", colours, FONT)}
                        onClick={() => {
                            navigate("/insight-admin");
                        }}
                    >
                        Insight Admin
                    </Typography>
                </Typography>
            </Grid>
        </>
    )
}

export default SettingHeader;